import { Button, Col, FormGroup, Input, Label, Row, Table } from "reactstrap";
import "./styles.css";
import DatePicker from "react-datepicker";
import { useContext, useState } from "react";
import api from "../../../../services/axiosConfig";
import { ptBR } from "date-fns/locale";
import { toast } from "react-toastify";
import { Context } from "../../../../hooks/useAuthContext";

import Swal from "sweetalert2";
import FullScreenLoader from "../../../../components/FullScreenLoader/FullScreenLoader";

export default function DashUpload() {
  const { exibirLogs } = useContext(Context);
  const [selectedDate, setSelectedDate] = useState();
  const [selectedEndDate, setSelectedEndDate] = useState();
  const [receitas, setReceitas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buscou, setBuscou] = useState(false);
  const [limit, setLimit] = useState(10);
  const [checked, setChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
    if (isChecked) {
      setLimit(receitas.length);
    } else {
      setLimit(10);
    }
  };

  async function fetchReceitas() {
    if (!selectedDate) {
      toast.warning("Selecione uma data antes de buscar.");
      return;
    }

    setLoading(true);
    setBuscou(true);

    try {
      const params = {};

      if (selectedDate) {
        const inicio = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate()
        );
        inicio.setUTCHours(0, 0, 0, 0);
        params.dataInicio = inicio.getTime();
      }

      if (selectedEndDate) {
        const fim = new Date(
          selectedEndDate.getFullYear(),
          selectedEndDate.getMonth(),
          selectedEndDate.getDate()
        );
        fim.setUTCHours(0, 0, 0, 0);
        params.dataFim = fim.getTime();
      }

      const response = await api.get("/admin/receitas", { params });

      setReceitas(response.data.receitasBase || []);
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar receitas:", error);
      toast.error("Erro ao buscar dados.");
      setReceitas([]);
    } finally {
      setLoading(false);
    }
  }

  async function handleDeleteReceitas() {
    if (!selectedDate && !selectedEndDate) {
      toast.warning("Selecione um periodo antes de apagar.");
      return;
    }

    const result = await Swal.fire({
      title: "Atenção!",
      text: "Você deseja apagar todas as receitas desse dia?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sim, apagar tudo!",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) {
      return;
    }

    setLoading(true);

    try {
      let timestampInicio;
      let timestampFim;

      if (selectedDate) {
        const inicio = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate()
        );
        inicio.setUTCHours(0, 0, 0, 0);
        timestampInicio = inicio.getTime();
      }

      if (selectedDate) {
        const fim = new Date(
          selectedEndDate.getFullYear(),
          selectedEndDate.getMonth(),
          selectedEndDate.getDate()
        );
        fim.setUTCHours(0, 0, 0, 0);
        timestampFim = fim.getTime();
      }

      const response = await api.delete("/admin/excluir-receitas", {
        params: { dataInicio: timestampInicio, dataFim: timestampFim },
      });

      toast.success(
        response.data.mensagem || "Receitas removidas com sucesso."
      );
      setReceitas([]);
    } catch (error) {
      exibirLogs && console.error("Erro ao apagar receitas:", error);
      toast.error("Erro ao apagar receitas.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && <FullScreenLoader />}
      <div>
        <h3 className="titleDash">Todos os relatórios</h3>
        <Row>
          <Col md={2}>
            <FormGroup className="filterGroup">
              <label htmlFor="filter">Data:</label>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="dd/MM/yyyy"
                locale={ptBR}
                className="dateInputDash"
                placeholderText="Selecione uma data"
                autoComplete="off"
              />
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup className="filterGroup">
              <label htmlFor="filter">Data final:</label>
              <DatePicker
                selected={selectedEndDate}
                onChange={(date) => setSelectedEndDate(date)}
                dateFormat="dd/MM/yyyy"
                locale={ptBR}
                className="dateInputDash"
                placeholderText="Selecione uma data"
                autoComplete="off"
              />
            </FormGroup>
          </Col>
          <Col md={2} sm={6} xs={6}>
            <FormGroup className="filterGroup">
              <br />
              <Button color="success" block onClick={fetchReceitas}>
                Buscar
              </Button>
            </FormGroup>
          </Col>

          <Col md={2} sm={6} xs={6}>
            <FormGroup className="filterGroup">
              <br />
              <Button
                color="danger"
                block
                onClick={handleDeleteReceitas}
                disabled={receitas.length === 0}
              >
                Apagar tudo
              </Button>
            </FormGroup>
          </Col>
        </Row>

        <div className="tableResponsive">
          {loading ? (
            <div>Loading...</div>
          ) : (
            <Table striped bordered responsive>
              <thead>
                <tr>
                  <th>Datadoc</th>
                  <th>CodeUtm</th>
                  <th>utmCampaign</th>
                  <th>Impressões</th>
                  <th>Receitas</th>
                </tr>
              </thead>
              <tbody>
                {receitas.length > 0 ? (
                  receitas
                    .slice(0, limit)
                    .sort((a, b) => b.receita - a.receita)
                    .map((receita) => (
                      <tr key={receita.id}>
                        <td>{receita.data}</td>
                        <td>{receita.codeUtm || "Sem dados"}</td>
                        <td>{receita.utmCampaign || "Sem dados"}</td>
                        <td>{receita.impressoes}</td>
                        <td>$ {receita.receita.toFixed(2)}</td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      {buscou
                        ? "Nenhum dado encontrado para a data selecionada."
                        : "Nenhuma busca realizada ainda."}
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot className="rowFooter">
                <tr>
                  <td colSpan="5" style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "flex-start",
                      }}
                    >
                      {receitas.length > 0 ? (
                        <span>{`Mostrando ${limit} de ${receitas.length}`}</span>
                      ) : (
                        "0 registros"
                      )}

                      {receitas.length > 0 && (
                        <Label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 5,
                            marginBottom: 3,
                          }}
                        >
                          <Input
                            type="checkbox"
                            checked={checked}
                            onChange={handleCheckboxChange}
                            className="ms-2"
                            valid
                          />
                          <span>Mostrar todas</span>
                        </Label>
                      )}
                    </div>
                  </td>
                </tr>
              </tfoot>
            </Table>
          )}
        </div>
      </div>
    </>
  );
}
